import { useCallback, useEffect, useState } from "react"
import { Template } from "../../Components/Template/template"
import {
    AlertType, BancoSearchBox, Cheque, ChequeEstorno, classBorderLabelDark, classBt, classbtAzul, classbtCinzaClaro, classbtColunasAzul, classbtColunasVermelho, classBtSemDuration, classbtVerde,
    classbtVermelho, classDivBackground, classDivBody, classDivTitulo, classInput, classInputDark, classLabel, classLabelDark, ClientesSearchBox, LanctoChequeAttributes
} from "../../Utils/Types"
import { FeedbackMessage } from "../../Components/FeedbackMessage/feedback-message"
import moment from "moment"
import { Link } from "react-router-dom"
import { IoAddCircleSharp, IoSearch } from "react-icons/io5"
import { SearchBox } from "../../Components/SearchBox/SearchBox"
import { ControleChequesService } from "./ControleChequesService"
import { GridCheques } from "../../Components/GridProducts/GridCheques"
import { ModalLiqCheques } from "../../Components/Modal/modal-liq-cheques"
import { AiOutlineClear } from "react-icons/ai"
import { FaMoneyCheckAlt, FaTrash } from "react-icons/fa"
import { Funcoes } from "../../Utils/Funcoes"
import { ModalEstCheque } from "../../Components/Modal/modal-estorna-cheques"
import { GridChequesEstorno } from "../../Components/GridProducts/GridChequesEstorno"
import { Tooltip } from 'react-tooltip'

export const ChequesPage = () => {

    let dateI = moment()
        .utcOffset('-03:00')
        .format('YYYY-MM-DD')

    let dateF = moment()
        .utcOffset('-03:00')
        .add(31, 'days')
        .format('YYYY-MM-DD')

    // ---------- ATRIBUTOS FEEDBACK -----------------
    const [loading, setLoading] = useState(false)
    const [visible, setVisible] = useState(false)
    const [message, setMessage] = useState("")
    const [messageType, setMessageType] = useState<AlertType>("DANGER")

    // ---------- ATRIBUTOS FILTRO -------------------
    const [dataLancaInicial, setDataLancaInicial] = useState(dateI)
    const [dataLancaFinal, setDataLancaFinal] = useState(dateF)
    const [numero, setNumero] = useState("")

    const [idBanco, setIdBanco] = useState(0)
    const [bancoList, setBancoList] = useState<BancoSearchBox[]>([])

    const [idCliente, setIdCliente] = useState(0)
    const [clientesList, setClientesList] = useState<ClientesSearchBox[]>([])

    const [filtroCheque, setFiltroCheque] = useState("A")
    const [status, setStatus] = useState("N")

    const [bordero, setBordero] = useState("")

    // ---------- ATRIBUTOS GRID ---------------------     
    const [attributes, setAttributes] = useState<LanctoChequeAttributes>()
    const [chequesList, setChequesList] = useState<Cheque[]>([])
    const [chequesEstornoList, setChequesEstornoList] = useState<ChequeEstorno[]>([])

    // ------------- DADOS DUPLICATA -----------------
    const [qtdCheque, setQtdCheque] = useState(0)
    const [totCheque, setTotCheque] = useState(0)
    const [qtdChequeSelecionado, setQtdChequeSelecionado] = useState(0)
    const [totSelecionado, setTotSelecionado] = useState(0)
    const [chequeSelectedList, setChequeSelectedList] = useState<number[]>([])
    const [borderoSelectedList, setBorderoSelectedList] = useState<number[]>([])
    const [selectDupAll, setSelectDupAll] = useState(false)

    // ------------- MODAL ---------------------------
    const [visible_modal_liq_cheques, setVisible_Modal_Liq_Cheques] = useState(false)
    const [visible_modal_estorno_cheques, setVisible_Modal_Estorno_Cheques] = useState(false)

    // ------------- SEARCHBOX ---------------------------
    const [visibleSearchBoxBanco, setVisibleSearchBoxBanco] = useState<boolean>(false)
    const [visibleSearchBoxCliente, setVisibleSearchBoxCliente] = useState<boolean>(false)


    //------------------------------------------------------------- REQUISIÇÃO API, ATALHOS E FOCUS ----------------------------------------------------------------------------//
    const GetAttributes = async () => {
        setLoading(true)

        try {

            const attr = await ControleChequesService.GetAttributes()
            setAttributes(attr.data)

        } catch (error) {

            setVisible(true)
            setMessageType("DANGER")
            setMessage(`Não foi possível buscar os dados do banco/cliente`)

        } finally {

            const timer = setTimeout(() => {
                setLoading(false)
                clearTimeout(timer)
            }, 0)
        }
    }

    const handleMouseUp = useCallback((e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        // Desfocar o link após o clique
        const target = e.target as HTMLElement
        if (target instanceof HTMLAnchorElement) {
            target.blur()
        }
    }, [])

    const handleKeyPressEnter = async (e: any) => {

        let menuFiltro = document.getElementById("divMenuFiltroCheque") as HTMLDivElement

        if ((e.code === "Enter" || e.code === "NumpadEnter") && !visibleSearchBoxBanco && !visibleSearchBoxCliente && !visible_modal_liq_cheques && !visible_modal_estorno_cheques && !loading && menuFiltro.classList.contains("max-h-[1000px]")) {
            await handleFilterClick()
        }
    }

    const handleTabPressNone = (event: any) => {

        if (event.key === 'Tab') {
            event.preventDefault() // Evita o comportamento padrão do 'Tab'
        }
    }

    useEffect(() => {
        document.addEventListener('keydown', handleKeyPressEnter)
        document.addEventListener('keydown', handleTabPressNone)

        return () => {
            document.removeEventListener('keydown', handleKeyPressEnter)
            document.removeEventListener('keydown', handleTabPressNone)
        }

    }, [dataLancaInicial, dataLancaFinal, filtroCheque, status, idBanco, idCliente, numero, bordero, visible_modal_liq_cheques, visible_modal_estorno_cheques, visibleSearchBoxBanco, visibleSearchBoxCliente, loading])

    useEffect(() => {
        GetAttributes()
    }, [])

    useEffect(() => {
        setChequesList([])
        setChequesEstornoList([])
        setChequeSelectedList([])
        setBorderoSelectedList([])
        setTotSelecionado(0)
        setSelectDupAll(false)
        setQtdCheque(0)
        setTotCheque(0)
        setQtdChequeSelecionado(0)
        setBordero("")
    }, [filtroCheque])

    const handleCloseMessage = () => {
        setVisible(false)
    }

    const searchBoxFocus = () => {
        setVisibleSearchBoxBanco(false)
        setVisibleSearchBoxCliente(false)
    }

    //--------------------------------------------------------------------------------------------- FILTROS ------------------------------------------------------------------------------------------//
    const handleFilterClick = async () => {

        setVisible(false)
        setLoading(true)

        setChequesList([])
        setChequesEstornoList([])
        setChequeSelectedList([])
        setBorderoSelectedList([])
        setTotSelecionado(0)
        setSelectDupAll(false)
        setQtdCheque(0)
        setTotCheque(0)
        setQtdChequeSelecionado(0)

        searchBoxFocus()

        try {

            if (filtroCheque === 'A') {

                const relatorio = {
                    datai: dataLancaInicial,
                    dataf: dataLancaFinal,
                    filtrar_data_por: filtroCheque,
                    status: status,
                    id_cliente: idCliente,
                    id_banco: idBanco,
                    numero: numero
                }

                const resp = await ControleChequesService.Filter(relatorio)

                if (resp.error) {

                    setVisible(true)
                    setMessageType("DANGER")
                    setMessage(resp.msg || '')

                } else {

                    setChequesList(resp.data.cheque)
                    setQtdCheque(resp.data.qtdCheque)
                    setTotCheque(resp.data.total)
                }

            } else {

                const relatorio = {
                    datai: dataLancaInicial,
                    dataf: dataLancaFinal,
                    filtrar_data_por: filtroCheque,
                    status: status,
                    id_cliente: idCliente,
                    id_banco: idBanco,
                    numero: numero,
                    bordero: bordero
                }

                const resp = await ControleChequesService.FilterBordero(relatorio)

                if (resp.error) {

                    setVisible(true)
                    setMessageType("DANGER")
                    setMessage(resp.msg || '')

                } else {

                    setChequesEstornoList(resp.data.chequeEstorno)
                    setQtdCheque(resp.data.qtdCheque)
                    setTotCheque(resp.data.total)
                }

            }

        } catch (error) {

            setVisible(true)
            setMessageType("DANGER")
            setMessage(`Não foi possível buscar os dados do cheque`)

        } finally {

            const timer = setTimeout(() => {
                setLoading(false)
                clearTimeout(timer)
            }, 1500)
        }
    }

    const filterDados = useCallback(async () => {

        setVisible(false)
        setChequesList([])
        setChequesEstornoList([])
        setChequeSelectedList([])
        setBorderoSelectedList([])
        setTotSelecionado(0)
        setSelectDupAll(false)
        setQtdCheque(0)
        setTotCheque(0)
        setQtdChequeSelecionado(0)

        try {

            if (filtroCheque === 'A') {

                const relatorio = {
                    datai: dataLancaInicial,
                    dataf: dataLancaFinal,
                    filtrar_data_por: filtroCheque,
                    status: status,
                    id_cliente: idCliente,
                    id_banco: idBanco,
                    numero: numero
                }

                const resp = await ControleChequesService.Filter(relatorio)

                if (resp.error) {

                    setVisible(true)
                    setMessageType("DANGER")
                    setMessage(resp.msg || '')
                    return false

                } else {

                    setChequesList(resp.data.cheque)
                    setQtdCheque(resp.data.qtdCheque)
                    setTotCheque(resp.data.total)
                    return true
                }

            } else {

                const relatorio = {
                    datai: dataLancaInicial,
                    dataf: dataLancaFinal,
                    filtrar_data_por: filtroCheque,
                    status: status,
                    id_cliente: idCliente,
                    id_banco: idBanco,
                    numero: numero,
                    bordero: bordero
                }

                const resp = await ControleChequesService.FilterBordero(relatorio)

                if (resp.error) {

                    setVisible(true)
                    setMessageType("DANGER")
                    setMessage(resp.msg || '')
                    return false

                } else {

                    setChequesEstornoList(resp.data.chequeEstorno)
                    setQtdCheque(resp.data.qtdCheque)
                    setTotCheque(resp.data.total)
                    return true
                }
            }

        } catch (error) {

            setVisible(true)
            setMessageType("DANGER")
            setMessage(`Não foi possível buscar os dados do cheque`)
            return false

        }

    }, [chequesList, dataLancaInicial, dataLancaFinal, filtroCheque, status, idCliente, idBanco, numero, bordero])

    const toggleMenuFiltro = (event: any) => {

        let menuFiltro = document.getElementById("divMenuFiltroCheque") as HTMLDivElement

        //let menuControl = document.getElementById("divMenuControlCheque") as HTMLDivElement

        let menuInputs = document.getElementById("divInputsCheque") as HTMLDivElement

        searchBoxFocus()

        if (menuFiltro) {

            menuFiltro.classList.toggle("max-h-[1000px]")
            menuFiltro.classList.toggle("max-h-[0px]")

            if (menuFiltro.classList.contains("max-h-[1000px]")) {

                //setSearchBoxResponsivo(true)
                menuInputs.classList.remove("invisible")

                const timer = setTimeout(() => {
                    clearTimeout(timer)
                }, 150)

            } else {

                //setSearchBoxResponsivo(false)
                menuInputs.classList.add("invisible")
            }

            event.currentTarget.blur()
        }
    }

    const handleLimparFiltros = () => {

        setDataLancaInicial(dateI)
        setDataLancaFinal(dateF)
        setNumero("")
        setIdBanco(0)
        setIdCliente(0)
        setFiltroCheque("A")
        setStatus("N")

        setBordero("")

        if (messageType === 'DANGER') {
            setVisible(false)
        }

        searchBoxFocus()
    }

    const handleChangeDtLancaInicial = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDataLancaInicial(e.target.value)
    }

    const handleChangeDtLancaFinal = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDataLancaFinal(e.target.value)
    }

    const handleChangeFiltroCheque = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const fieldMap: { [key: string]: string } = {
            'A': 'A',
            'B': 'B',
        }

        const selectedField = fieldMap[e.target.value]

        if (selectedField) {
            setFiltroCheque(selectedField)
        }
    }

    const handleChangeStatus = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const fieldMap: { [key: string]: string } = {
            'N': 'N',
            'R': 'R',
            'D': 'D',
        }

        const selectedField = fieldMap[e.target.value]

        if (selectedField) {
            setStatus(selectedField)
        }
    }

    const handleChangeNumero = (e: React.ChangeEvent<HTMLInputElement>) => {
        setNumero(e.target.value.replace(/[^0-9]/g, ''))
    }

    const handleChangeBordero = (e: React.ChangeEvent<HTMLInputElement>) => {
        setBordero(e.target.value.replace(/[^0-9]/g, ''))
    }

    // --------------------------------------------------------------  BANCOS -------------------------------------------------------------------------
    const handleClearBancoSelecionado = useCallback(() => {

        setIdBanco(0)

        setVisibleSearchBoxBanco(false)

    }, [attributes?.bancos])

    const handleSetBancoClick = useCallback((v: BancoSearchBox) => {

        if (v) {
            const newBancoList = [...attributes?.bancos || []]
            setBancoList(newBancoList)
            setIdBanco(v.id)
        }

        setVisibleSearchBoxBanco(false)

    }, [attributes?.bancos])

    const handleFilterBancoClick = useCallback((description: any) => {

        if (description === "") {

            const newUfList = [...attributes?.bancos || []]
            setBancoList(newUfList)

        } else {

            let newBancos

            if (!isNaN(description)) {

                newBancos = [...attributes?.bancos || []].filter((banco) => {
                    const codigoSubstring = banco.id.toString().substring(0, 3)
                    return codigoSubstring.startsWith(description)
                })

            } else {

                newBancos = [...attributes?.bancos || []].filter((banco) => banco.description.toLocaleLowerCase().startsWith(description.toLocaleLowerCase()))
            }

            setBancoList(newBancos)
        }
    }, [attributes?.bancos])

    const clickSearchBoxBanco = useCallback(() => {
        setVisibleSearchBoxBanco((prevState) => {
            const newState = !prevState // Alterna o estado atual
            if (newState) {
                setVisibleSearchBoxCliente(false)
                inputFocusBanco()
            }
            return newState
        })
    }, [])

    const inputFocusBanco = () => {
        let inputSearch = document.getElementById(`inputSearchBox-banco`) as HTMLInputElement

        const timer = setTimeout(() => {
            inputSearch?.focus()
            clearTimeout(timer)
        }, 10)
    }

    // --------------------------------------------------------------  CLIENTES -------------------------------------------------------------------------
    const handleClearClienteSelecionado = useCallback(() => {

        setIdCliente(0)

        setVisibleSearchBoxCliente(false)

    }, [attributes?.clientes])

    const handleSetClienteClick = useCallback(async (v: ClientesSearchBox) => {

        if (v) {
            const newClienteList = [...attributes?.clientes || []]
            setClientesList(newClienteList)
            setIdCliente(v.id)
        }

        setVisibleSearchBoxCliente(false)

    }, [attributes?.clientes])

    const handleFilterClienteClick = useCallback(async (description: string) => {

        if (description === "") {

            const newClienteList = [...attributes?.clientes || []]
            setClientesList(newClienteList || [])

        } else {

            const newClienteList = [...attributes?.clientes || []].filter((item) => {
                return item.description.toLocaleLowerCase().startsWith(description.toLocaleLowerCase())
            })
            setClientesList(newClienteList || [])
        }

    }, [attributes?.clientes])

    const clickSearchBoxCliente = useCallback(() => {
        setVisibleSearchBoxCliente((prevState) => {
            const newState = !prevState // Alterna o estado atual
            if (newState) {
                setVisibleSearchBoxBanco(false)
                inputFocusCliente()
            }
            return newState
        })
    }, [])

    const inputFocusCliente = () => {
        let inputSearch = document.getElementById(`inputSearchBox-cliente`) as HTMLInputElement

        const timer = setTimeout(() => {
            inputSearch?.focus()
            clearTimeout(timer)
        }, 10)
    }

    //---------------------------------------------------------------- FUNÇÕES DA GRID ------------------------------------------------------------------
    const handleColumnClick = useCallback(() => {

        let newChequeList = [...chequesList]
        newChequeList = [...chequesList]
        let total = 0

        for (let i in newChequeList) {
            newChequeList[i].selected = !selectDupAll
            total += newChequeList[i].valor
        }

        if (selectDupAll) {
            setTotSelecionado(0)
        } else {
            setTotSelecionado(total)
        }

        setChequesList(newChequeList)
        setSelectDupAll(!selectDupAll)

    }, [chequesList, selectDupAll])

    const handleCheckBoxClick = useCallback(async (id: number, selected: boolean) => {

        const newChequeList = [...chequesList]
        const index = newChequeList.findIndex((item) => item.id === id)

        if (index >= 0) {

            // Evita atualizar a lista inteira
            newChequeList[index].selected = !selected
            const itemSelecionado = newChequeList[index]

            setChequesList(newChequeList)

            // Atualiza apenas o totSelecionado usando o valor atual como base
            setTotSelecionado((prevTotal) => {
                let newTotal = prevTotal

                if (!selected) {
                    newTotal += itemSelecionado.valor
                } else {
                    newTotal -= itemSelecionado.valor
                }

                return newTotal
            })

            /*
            newChequeList[index].selected = selected
            if (selected) {
                total += newChequeList[index].valor
            } else {
                total -= newChequeList[index].valor
            }
    
            setChequesList(newChequeList)
            setTotSelecionado(total)
            */
        }
    }, [chequesList])

    const handleCheckBoxEstornoClick = useCallback(async (id: number, selected: boolean) => {

        const newChequeList = [...chequesEstornoList]
        const index = newChequeList.findIndex((item) => item.id_bordero === id)

        if (index >= 0) {

            // Evita atualizar a lista inteira
            newChequeList[index].selected = !selected
            const itemSelecionado = newChequeList[index]

            setChequesEstornoList(newChequeList)

            setTotSelecionado((prevTotal) => {
                let newTotal = prevTotal
                let valor = itemSelecionado.valor || 0

                if (!selected) {
                    newTotal += valor
                } else {
                    newTotal -= valor
                }

                return parseFloat(newTotal.toFixed(2))
            })

            setQtdChequeSelecionado((prevTotal) => {
                let newTotal = prevTotal

                if (!selected) {
                    newTotal += itemSelecionado.qtd // Se foi desmarcado, subtrai
                } else {
                    newTotal -= itemSelecionado.qtd // Se foi marcado, adiciona
                }

                return newTotal
            })
        }

    }, [chequesEstornoList])

    const abriModalLiqCheques = async () => {

        setVisible(false)
        searchBoxFocus()

        let newChequeList = [...chequesList]
        newChequeList = newChequeList.filter((item) => item.selected === true)
        const newChequeSelectedList: number[] = []

        if (newChequeList.length === 0) {

            const timer = setTimeout(() => {
                setVisible(true)
                setMessageType("DANGER")
                setMessage(`Nenhum cheque selecionado`)
                clearTimeout(timer)
            }, 250)

            return
        }

        newChequeList.map((item) => newChequeSelectedList.push(item.id))
        setChequeSelectedList(newChequeSelectedList)
        setVisible_Modal_Liq_Cheques(true)

    }

    const abriModalEstornoCheques = async () => {

        setVisible(false)
        searchBoxFocus()

        let newChequeList = [...chequesEstornoList]

        newChequeList = newChequeList.filter((item) => item.selected === true)
        const newCtaSelectedList: number[] = []
        const newBorderoList: number[] = []

        newChequeList.map((item) => newCtaSelectedList.push(item.id_bordero))
        newChequeList.map((item) => newBorderoList.push(item.id_bordero))
        setChequeSelectedList(newCtaSelectedList || [])
        setBorderoSelectedList(newBorderoList)
        setVisible_Modal_Estorno_Cheques(true)

    }

    const fecharModalLiqCheques = useCallback(() => {
        setVisible_Modal_Liq_Cheques(false)
    }, [])

    const fecharModalEstornoCheques = useCallback(() => {
        setVisible_Modal_Estorno_Cheques(false)
    }, [])

    return (
        <Template isLoading={loading}>

            <div className={`${classDivBackground}`}>

                <div role='button' id="div-body" className={`${classDivBody}`}>

                    <FeedbackMessage visible={visible} message={message} type={messageType} onCloseMessage={handleCloseMessage} />

                    <div className={`${classDivTitulo} grid grid-cols-12 gap-4 p-2`}>

                        <div className={`relative col-span-12 sm:col-span-10 xl:col-span-5 flex flex-row items-center`}>
                            {/* <img src={iconCheque} alt="" style={{ width: '30px', height: '30px', filter: tema === 'dark' ? 'invert(100%) ' : 'invert(30%) ' }} className={`mr-2 ml-2 `} /> */}

                            <FaMoneyCheckAlt className={`mx-2 text-slate-700 dark:text-slate-200`} size="25px" />
                            <span className={`text-base md:text-lg xl:text-2xl text-slate-700 dark:text-slate-200`}>Cheques</span>
                        </div>

                        <div className={`relative col-span-12 sm:col-span-2 xl:col-span-1`}>

                            <Link tabIndex={-1} onMouseUp={handleMouseUp} to={'/c_cheque/excluidos'} data-tooltip-id={'tooltip-btn-lixeira'} id={'btn-lixeira'} className={`${classbtColunasVermelho} h-9`} >
                                <FaTrash className={`mx-2`} size="25px" />
                            </Link>

                            <Tooltip style={{ backgroundColor: 'rgb(239, 68, 68)' }} id={'tooltip-btn-lixeira'} anchorSelect={'#btn-lixeira'} positionStrategy="fixed" place='left' >
                                <span>Cheques Excluídos</span>
                            </Tooltip>
                        </div>

                        <div className={`relative col-span-12 sm:col-span-4 xl:col-span-2`}>
                            <button className={` ${classbtColunasAzul} h-9`} onClick={toggleMenuFiltro}>
                                <span className={`w-full h-full flex justify-center items-center`}>Filtros </span>
                            </button>
                        </div>

                        <div className={`relative col-span-12 sm:col-span-4 xl:col-span-2`}>
                            {filtroCheque === "A" &&
                                <button tabIndex={-1} disabled={loading || totSelecionado === 0} className={`${loading || totSelecionado === 0 ? `opacity-40` : ``} ${classBt} ${classbtAzul} disabled:cursor-not-allowed w-full h-9`} onClick={abriModalLiqCheques}>
                                    <span className='mx-1'>Baixar Cheques</span>
                                </button>
                            }

                            {filtroCheque === "B" &&
                                <button tabIndex={-1} disabled={loading || totSelecionado === 0} className={`${loading || totSelecionado === 0 ? `opacity-40` : ``} ${classBt} ${classbtVermelho} disabled:cursor-not-allowed w-full h-9`} onClick={abriModalEstornoCheques}>
                                    <span className='mx-1'>Estornar Cheques</span>
                                </button>
                            }
                        </div>

                        <div className={`relative col-span-12 sm:col-span-4 xl:col-span-2`}>
                            <Link onMouseUp={handleMouseUp} to={"/c_cheque/new"} className={`${classbtVerde} ${classBt} h-9`}>
                                <IoAddCircleSharp size="20px" className={`mr-2 hidden md:block`} /> Cadastro
                            </Link>
                        </div>

                    </div>

                    <div id='divInputsCheque' className={`relative invisible ease-in-out duration-[150ms]`}>

                        <div id='divMenuFiltroCheque' className={`max-h-[0px] h-[780px] sm:h-[450px] md:h-[350px] xl:h-[280px] cursor-default bg-white dark:bg-slate-600 shadow-sm shadow-slate-400 dark:shadow-slate-800 border dark:border-slate-800 rounded-md overflow-y-hidden`} style={{ transitionDuration: "0ms, 300ms", transitionProperty: "background-color, max-height" }} />

                        <div className={`absolute top-0 w-full h-auto grid grid-cols-12 gap-3 py-4 px-3`}>

                            <div className={`relative col-span-12 sm:col-span-4 xl:col-span-3 2xl:col-span-2 mt-2`}>
                                <input id="dataLancamento" className={`${classInput} ${classInputDark} ${dataLancaInicial === "" ? `text-blue-500 dark:text-cyan-300` : ``} dark:[color-scheme:dark]`} type='date' min="1900-01-01" max="9999-12-31" placeholder=" " value={dataLancaInicial} onFocus={searchBoxFocus} onChange={handleChangeDtLancaInicial} />
                                <label htmlFor="dataLancamento" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Data Lançamento Inicial</label>
                            </div>

                            <div className={`relative col-span-12 sm:col-span-4 xl:col-span-3 2xl:col-span-2 mt-2`}>
                                <input id="dataLancamento" className={`${classInput} ${classInputDark} ${dataLancaFinal === "" ? `text-blue-500 dark:text-cyan-300` : ``} dark:[color-scheme:dark]`} type='date' min="1900-01-01" max="9999-12-31" placeholder=" " value={dataLancaFinal} onFocus={searchBoxFocus} onChange={handleChangeDtLancaFinal} />
                                <label htmlFor="dataLancamento" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Data Lançamento Final</label>
                            </div>

                            <div className={`relative col-span-12 sm:col-span-4 xl:col-span-2 mt-2`}>
                                <input id="numero" className={`${classInput} ${classInputDark}`} placeholder=' ' type='text' autoComplete="off" value={numero} onFocus={searchBoxFocus} onChange={handleChangeNumero} />
                                <label htmlFor="numero" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Número</label>
                            </div>

                            <div id="componenteBanco" className={`relative col-span-12 md:col-span-6 xl:col-span-4 2xl:col-span-3 mt-2`}>
                                <SearchBox
                                    dataList={bancoList}
                                    idRegistro={idBanco}
                                    label="Banco"
                                    componentId='banco'
                                    limite={true}
                                    visibleTAB={visibleSearchBoxBanco}
                                    clearDataClick={handleClearBancoSelecionado}
                                    setDataClick={handleSetBancoClick}
                                    filterDataClick={handleFilterBancoClick}
                                    clicado={clickSearchBoxBanco} />
                            </div>

                            <div id="componenteCliente" className={`relative col-span-12 md:col-span-6 2xl:col-span-3 mt-2`}>
                                <SearchBox
                                    dataList={clientesList}
                                    idRegistro={idCliente}
                                    label="Cliente"
                                    componentId='cliente'
                                    visibleTAB={visibleSearchBoxCliente}
                                    clearDataClick={handleClearClienteSelecionado}
                                    setDataClick={handleSetClienteClick}
                                    filterDataClick={handleFilterClienteClick}
                                    clicado={clickSearchBoxCliente} />
                            </div>

                            <div className={`relative col-span-12 sm:col-span-4 xl:col-span-2 mt-2`}>
                                <select id='filterCheque' disabled={loading} className={`${classInput} ${classInputDark}`} value={filtroCheque} onFocus={searchBoxFocus} onChange={handleChangeFiltroCheque} >
                                    <option value="A">Abertos</option>
                                    <option value="B">Baixados</option>
                                </select>
                                <label htmlFor="filterCheque" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Cheques</label>
                            </div>

                            <div className={`relative col-span-12 sm:col-span-4 xl:col-span-2 mt-2`}>
                                <select id='status' disabled={loading} className={`${classInput} ${classInputDark}`} value={status} onFocus={searchBoxFocus} onChange={handleChangeStatus} >
                                    <option value="N">Normal</option>
                                    <option value="D">Devolvidos </option>
                                    <option value="R">Representado </option>
                                </select>
                                <label htmlFor="status" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Status</label>
                            </div>

                            <div className={`relative col-span-12 sm:col-span-4 xl:col-span-2 mt-2`}>
                                <input id="bordero_cheque" className={`${classInput} ${classInputDark} `} type='text' inputMode="numeric" placeholder=' ' autoComplete='off' value={bordero} disabled={loading || filtroCheque === "A"} onFocus={searchBoxFocus} onChange={handleChangeBordero} />
                                <label htmlFor="bordero_cheque" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Borderô</label>
                            </div>

                            <div className={`col-span-12 flex flex-col sm:flex-row justify-end sm:space-x-2 mt-3`}>

                                <div className={`relative mt-2 sm:mt-0`}>

                                    <button className={`${classBtSemDuration} ${classbtCinzaClaro} w-full sm:min-w-[150px]`} onClick={handleLimparFiltros}>
                                        <AiOutlineClear size="20px" className={`mr-[2px]`} /><span className='mx-1'>Limpar Campos</span>
                                    </button>

                                </div>

                                <div className={`relative mt-6 sm:mt-0`}>
                                    <button disabled={loading} className={`${loading ? `opacity-40` : ``} ${classbtColunasAzul} w-full sm:min-w-[150px]`} onClick={handleFilterClick}>
                                        <span className={`w-full h-full flex justify-center items-center`}>
                                            {!loading && <IoSearch size="20px" className={`mr-2`} />}
                                            {loading &&
                                                <div className={`h-[20px] w-[20px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-[#2980b9] dark:text-slate-200 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                                    <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                                                </div>
                                            }
                                            {!loading && `Pesquisar`} {loading && `Aguarde`}
                                        </span>
                                    </button>
                                </div>

                            </div>

                            <div className={`col-span-12`}>

                                <div className={`flex flex-col md:flex-row md:py-2 justify-start w-full h-auto border border-slate-500 rounded-md bg-gray-200 dark:bg-slate-700`}>

                                    <div className={`w-full md:w-[25%] font-mono py-1 px-2 dark:text-slate-200 flex flex-row border md:border-none border-x-0 border-t-0 dark:border-slate-500 border-slate-400`}>
                                        <span className={`w-full md:w-auto`}>N° Cheques: </span>
                                        <span id='qtdCheque' className={`w-full md:w-auto flex justify-end items-center md:ml-2`}>{qtdCheque}</span>
                                    </div>

                                    <div className={`w-full md:w-[35%] font-mono py-1 px-2 dark:text-slate-200 flex flex-row border md:border-none border-x-0 border-t-0 dark:border-slate-500 border-slate-400`}>
                                        <span className={`w-full md:w-auto`}>Total: </span>
                                        <span id='totCheque' className={`w-full md:w-auto flex justify-end items-center md:ml-2`}>{Funcoes.numberFormat(totCheque, 'currency')}</span>
                                    </div>

                                    <div className={`w-full md:w-[40%] font-mono py-1 px-2 dark:text-slate-200 flex flex-row`}>
                                        <span className={`w-full md:w-auto`}>Total Selecionado: </span>
                                        <span id='totSelecionadoCheque' className={`w-full md:w-auto flex justify-end items-center md:ml-2`}>{Funcoes.numberFormat(totSelecionado, 'currency')}</span>
                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>

                    <div className={`w-full cursor-default mt-1 z-0 border shadow-sm shadow-slate-400 dark:bg-slate-600 dark:border-slate-800 dark:shadow-slate-800 `}>


                        {filtroCheque === 'A' &&

                            <GridCheques
                                cheque={chequesList}
                                tipo={"A"}//filtroCheque === "A" ? "A" : "B"
                                selectedAll={selectDupAll}
                                handleSelectItemClick={handleCheckBoxClick}
                                handleColumnClick={handleColumnClick}
                                handleUpdateChequeList={filterDados}
                            />

                        }

                        {filtroCheque === 'B' &&

                            <GridChequesEstorno
                                cheque={chequesEstornoList}
                                handleSelectItemClick={handleCheckBoxEstornoClick}

                            />
                        }

                    </div>

                </div>

                <ModalLiqCheques
                    visible={visible_modal_liq_cheques}
                    totSelecionado={totSelecionado}
                    chequeSelectedList={chequeSelectedList}
                    handleModalClose={fecharModalLiqCheques}
                    handleConfirm={filterDados}
                />

                <ModalEstCheque
                    visible={visible_modal_estorno_cheques}
                    totSelecionado={totSelecionado}
                    qtdChequeSelecionado={qtdChequeSelecionado}
                    chequeSelectedList={chequeSelectedList}
                    bordero={borderoSelectedList}
                    handleModalClose={fecharModalEstornoCheques}
                    handleConfirm={filterDados}
                />

            </div>

        </Template>
    )
}